import React from 'react';
import { useNavigate } from 'react-router-dom';
import "./Dasboard.css"
import   { Navbar } from "./navbar"

export const  Dashboard = () => {

  const handleClick = () => {
    window.location.href = 'https://task-3-khushi89012.vercel.app/';
  }

  const handleAdmin = ()=>{
    window.location.href = 'https://task2-lilac.vercel.app/';
  }



 
  return(
    <div>

<Navbar />


<div className="btn-grp">
  <button
    onClick={handleAdmin}
    disabled
  > 
    Admin
  </button>

  <button
 onClick  = {handleClick}
   > 
     User 
   </button>

</div>

    </div>



  );
}